module.exports = __webpack_public_path__ + "img/ess_bg01.b0c3e825.svg";